import React from "react";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import Autocomplete from "@material-ui/lab/Autocomplete";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#1890ff",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#1890ff",
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "90%",
  },
  textFieldWrapper: {
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    textTransform: "none",
  },
  content: {
    flexGrow: 1,
  },
  securityBox: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
    alignItems: "center",
    border: "1px solid #D9D9D9",
    borderRadius: "4px",
    padding: "8px",
    // paddingTop: "8px",
    // paddingBottom: "8px",
    marginBottom: "16px",
  },
  inviteBtn: {
    backgroundColor: "#286acf",
    textTransform: "none",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#286acf",
    },
  },
    btnPrimary: {
    backgroundColor: "#286acf",
    textTransform: "none",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#286acf",
    },
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

const BrandData={
    status:true,
    data:[
   { brand: "Catalent Pharma Solutions" },
  { brand: "Lonza Group" },
  { brand: "Thermo Fisher Scientific" },
  { brand: "Samsung Biologics" },
  { brand: "Recipharm" },
  { brand: "Evonik Industries" },
  { brand: "WuXi AppTec" },
  { brand: "Boehringer Ingelheim BioXcellence" },
]
}

export default function Brand({ setShowComponent, profileData, brandData, setBrandData }) {
  const classes = useStyles();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedProductOptions, setSelectedProductOptions] = useState([]);
  const [cdmoAPI, setCdmoAPI] = useState([]);
  const [productType, setProductType] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  
  // Use a function in useState to safely get the initial state
  // This prevents the JSON.parse from running on every render
  const [accessOption, setAccessOption] = useState(() => {
    try {
      const savedState = sessionStorage.getItem('brandState');
      if (savedState) {
        const parsed = JSON.parse(savedState);
        return parsed.accessOption || "all";
      }
    } catch (e) {
      console.error("Error parsing saved state", e);
    }
    return "all";
  });
  
  const [associatedIds, setAssociatedIds] = useState(() => {
    try {
      const savedState = sessionStorage.getItem('brandState');
      if (savedState) {
        const parsed = JSON.parse(savedState);
        return parsed.accessOption === "select" ? "" : "all";
      }
    } catch (e) {
      console.error("Error parsing saved state", e);
    }
    return "all";
  });
  
  const [loginSecurity, setLoginSecurity] = useState({
    two_step_authenticated: false,
    // edit_phone_number: true,
    azure_ad_sign_in_enabled: false,
  });

  // Store state when navigating away
  const handleBack = () => {
    // Store current selections before navigating back
    const currentState = {
      accessOption,
      selectedOptions: selectedOptions.map(option => option.brand),
      selectedProductOptions: selectedProductOptions.map(option => option.productTypeID)
    };
    
    // Update both session storage and brandData
    sessionStorage.setItem('brandState', JSON.stringify(currentState));
    
    const brands = accessOption === 'all' 
      ? cdmoAPI.map(item => item.brand)
      : selectedOptions.map(option => option.brand);
      
    const products = selectedProductOptions.map(item => item.productTypeID);
    
    setBrandData({
      brands,
      products
    });
    
    setShowComponent("Profile");
  };

  const handleSubmit = () => {
    // Store current selections before navigating forward
    const currentState = {
      accessOption,
      selectedOptions: selectedOptions.map(option => option.brand),
      selectedProductOptions: selectedProductOptions.map(option => option.productTypeID)
    };
    
    // Update both session storage and brandData
    sessionStorage.setItem('brandState', JSON.stringify(currentState));
    
    const brands = accessOption === 'all' 
      ? cdmoAPI.map(item => item.brand)
      : selectedOptions.map(option => option.brand);
      
    const products = selectedProductOptions.map(item => item.productTypeID);
    
    setBrandData({
      brands,
      products
    });
    
    setShowComponent("CDMO");
  };

  // Initialize state with saved data when component mounts
  useEffect(() => {
    if (cdmoAPI && cdmoAPI.length > 0 && productType && productType.length > 0) {
      // Try to restore from session storage first
      const savedState = sessionStorage.getItem('brandState');
      
      if (savedState) {
        try {
          const parsedState = JSON.parse(savedState);
          
          // If the saved option is "all", select all brands
          if (parsedState.accessOption === 'all') {
            setSelectedOptions(cdmoAPI);
          }
          // Restore selected brand options for "select" mode
          else if (parsedState.accessOption === 'select') {
            if (parsedState.selectedOptions && parsedState.selectedOptions.length > 0) {
              // Only restore selections if there were explicitly selected options previously
              const matchedOptions = cdmoAPI.filter(item => 
                parsedState.selectedOptions.includes(item.brand)
              );
              
              if (matchedOptions.length > 0) {
                setSelectedOptions(matchedOptions);
              } else {
                // If no matched options found, ensure selections are cleared
                setSelectedOptions([]);
              }
            } else {
              // If no previous selections, ensure selections are cleared
              setSelectedOptions([]);
            }
          }
          
          // Restore selected product options
          if (parsedState.selectedProductOptions && parsedState.selectedProductOptions.length > 0) {
            const matchedProducts = productType.filter(product => 
              parsedState.selectedProductOptions.includes(product.productTypeID)
            );
            
            if (matchedProducts.length > 0) {
              setSelectedProductOptions(matchedProducts);
            }
          }
          
          // Don't update brandData here to prevent infinite loop
          
        } catch (e) {
          console.error("Error restoring Brand state:", e);
          fallbackToBrandData();
        }
      } 
      // Fallback to using brandData if no session storage
      else {
        fallbackToBrandData();
      }
    }
    
    // Helper function to restore from brandData
    function fallbackToBrandData() {
      if (brandData) {
        // If we have previously saved brands, restore the selections
        if (brandData.brands && brandData.brands.length > 0) {
          // Check if we have specific brands selected
          const savedBrands = Array.isArray(brandData.brands) ? brandData.brands : [brandData.brands];
          
          if (savedBrands.length < cdmoAPI.length) {
            setAccessOption("select");
            // Match the brand names with the API data
            const matchedOptions = cdmoAPI.filter(item => 
              savedBrands.includes(item.brand)
            );
            
            if (matchedOptions.length > 0) {
              setSelectedOptions(matchedOptions);
            }
          } else if (savedBrands.length === cdmoAPI.length) {
            // If all brands are selected, set to "all" mode
            setAccessOption("all");
            setSelectedOptions(cdmoAPI);
          }
        }

        // If we have previously saved products, restore the selections
        if (brandData.products && brandData.products.length > 0) {
          // Find and set the selected product options
          const savedProducts = Array.isArray(brandData.products) ? brandData.products : [brandData.products];
          const matchedProducts = productType.filter(product => 
            savedProducts.includes(product.productTypeID)
          );
          
          if (matchedProducts.length > 0) {
            setSelectedProductOptions(matchedProducts);
          }
        }
      }
    }
  }, [cdmoAPI, productType, brandData]);

  useEffect(() => {
    setLoading(true);

    // const url = `${appUrl}/user/fetchCdmoDetails`;
    const url =  `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllBrands`;
    // const url =
    //   "https://api.mockfly.dev/mocks/6068d47d-50f1-44a0-bc11-f2a155dab121/fetchCdmoDetails";
    axios
      .get(url)
      .then((res) => {
        // throw new Error("Error");
        // if (res.data.status) {
        //  setCdmoAPI(res.data);
        // //  setCdmoAPI(BrandData?.data);
        //   setError(null);
        // }
            if (res.data.status && Array.isArray(res.data.data?.Brands)) {
      const transformed = res.data.data.Brands.map((brand) => ({
        brand,
      }));
      setCdmoAPI(transformed); // ✅ correct shape for Autocomplete
      setError(null);
    } 
         else setCdmoAPI([]);
      })
      .catch((err) => {
        setError(err.message);
        console.error(err.message);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setLoading(true);

    // const url = `${appUrl}/user/fetchCdmoDetails`;
    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchProductTypes/false`;
    // const url =
    //   "https://api.mockfly.dev/mocks/6068d47d-50f1-44a0-bc11-f2a155dab121/fetchCdmoDetails";
    axios
      .get(url)
      .then((res) => {
        // throw new Error("Error");
        // if (res.data.status) {
        //  setCdmoAPI(res.data);
        // //  setCdmoAPI(BrandData?.data);
        //   setError(null);
        // }
            if (res.data.status && Array.isArray(res.data.data?.productTypeList)) {
      // const transformed = res.data.data.Brands.map((brand) => ({
      //   brand,
      // }));
      setProductType(res.data.data.productTypeList);
      setError(null);
    } 
         else setProductType([]);
      })
      .catch((err) => {
        setError(err.message);
        console.error(err.message);
      })
      .finally(() => setLoading(false));
  }, []);

  // This useEffect keeps selectedOptions in sync with accessOption and cdmoAPI
  useEffect(() => {
    // If "all" mode is selected and cdmoAPI is loaded, select all brands
    if (accessOption === "all" && cdmoAPI.length > 0) {
      setSelectedOptions(cdmoAPI);
      setAssociatedIds("all");
    }
  }, [cdmoAPI, accessOption]);

  // Effect to update brandData based on selections, but only when leaving the component
  // We'll remove this automatic update to prevent infinite loops
  // Instead, we'll update brandData only when navigating with handleBack or handleSubmit

  // Handle radio button change
  const handleAccessChange = (event) => {
    const value = event.target.value;
    setAccessOption(value);
    
    if (value === "all") {
      // When "Access all Brands" is selected, select all brands
      setSelectedOptions(cdmoAPI);
      setAssociatedIds("all");
    } else if (value === "select") {
      // When switching to "select" mode, always clear selections
      // This ensures when initially clicking "Access select Brands", all options are unchecked
      setSelectedOptions([]);
      setAssociatedIds("");
    }
  };

  const displayLoading = (
    <div style={{ textAlign: "center", marginTop: "1.5em" }}>
      <CircularProgress color="primary" thickness={7} />
    </div>
  );
  const displayError = (
    <Box
      style={{
        border: "2px solid rgb(255,0,0)",
        backgroundColor: "rgb(255,240,240)",

        textAlign: "center",
        padding: "0.8rem",
        fontSize: "0.875rem",
        marginTop: "1.5em",
      }}
    >
      {" "}
      <Typography variant="body2">
        Something went wrong. Please try again later.
      </Typography>
    </Box>
  );

  const displayNoRecordsFound = (
    <Box
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50px",
        border: "2px solid #000",
        // backgroundColor: "#FFF0F0",
        width: "100%",
        marginTop: "1.5em",
      }}
    >
      <Typography style={{ textAlign: "center" }}>No records found</Typography>
    </Box>
  );

  if (loading) return displayLoading;
  if (error) return displayError;
  if (!cdmoAPI || !cdmoAPI.length) return displayNoRecordsFound;
  return (
    <Box
      style={{ marginTop: "8px", width: "100%" }}
      className={classes.container}
    >
      <Box className={classes.content}>
        {localStorage.getItem("collabType") !== "CMO" && (
          <Box>
            <Typography
              style={{ fontSize: "16px", fontWeight: 600 }}
              gutterBottom
            >
              Associate Brand <span style={{ color: "red" }}>*</span>
            </Typography>
            <FormControl style={{ width: "100%" }}>
              <RadioGroup
                row={false}
                value={accessOption}
                onChange={handleAccessChange}
              >
                <FormControlLabel
                  value="all"
                  control={<Radio color="primary" />}
                  label={`Access all Brands (${cdmoAPI.length})`}
                />
                <FormControlLabel
                  value="select"
                  control={<Radio color="primary" />}
                  label="Access select Brands"
                />
              </RadioGroup>
            </FormControl>
            <FormControl style={{ width: "100%", height: "100%" }}>
              <Autocomplete
                multiple
                value={selectedOptions}
                options={cdmoAPI}
                getOptionLabel={(option) => option?.brand || "NA"}
                onChange={(event, value) => {
                  setSelectedOptions(value);
                  // Update associatedIds when selections change in "select" mode
                  if (accessOption === "select") {
                    const selectedIds = value.map(option => option.brand).join(",");
                    setAssociatedIds(selectedIds || "");
                  }
                }}
                disabled={accessOption === "all"}
                disableCloseOnSelect
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Start typing to search"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <Checkbox
                      checked={selected}
                      style={{ marginRight: 8 }}
                      color="primary"
                    />
                    {option.brand}
                  </React.Fragment>
                )}
              />
            </FormControl>
            <FormControl style={{ marginTop: "8px", width: "100%" }}>
              <Typography variant="body1">Your selections</Typography>
              <TextField
                disabled
                size="small"
                minRows={4}
                fullWidth
                value={
                  selectedOptions
                    .map((option) => option?.brand)
                    .join(", ") || ""
                } // Display selected names
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
                multiline
                style={{ width: "100%" }}
              />
            </FormControl>
          </Box>
        )}
            <Typography
              style={{ fontSize: "16px", fontWeight: 600 }}
              gutterBottom
            >
              Associate Product Types <span style={{ color: "red" }}>*</span>
            </Typography>


<FormControl component="fieldset" style={{ width: "100%" }}>
    <FormGroup>
    {productType.map((item) => (
      <FormControlLabel
        key={item.productTypeID}
        control={
          <Checkbox
            checked={selectedProductOptions.some(
              (selected) => selected.productTypeID === item.productTypeID
            )}
            onChange={(e) => {
              const isChecked = e.target.checked;
              let updatedSelection;
              if (isChecked) {
                updatedSelection = [...selectedProductOptions, item];
              } else {
                updatedSelection = selectedProductOptions.filter(
                  (pt) => pt.productTypeID !== item.productTypeID
                );
              }
              setSelectedProductOptions(updatedSelection);
              // Optional: setAssociatedIds(updatedSelection.map(i => i.productTypeID).join(","));
            }}
            color="primary"
          />
        }
        label={item.productTypeName}
      />
    ))}
  </FormGroup>
</FormControl>


      </Box>

      <Box className={classes.buttonContainer}>
        <Button
          size="small"
          variant="contained"
          disableElevation
          style={{ textTransform: "none" }}
          onClick={handleBack}
        >
          Back
        </Button>

        <Button
          className={classes.btnPrimary}
          variant="contained"
          size="small"
          style={{ textTransform: "none" }}
          onClick={handleSubmit}
          disabled={selectedOptions.length === 0 || selectedProductOptions.length === 0}
        >
          Continue and associate CMOs
        </Button>
      </Box>
    </Box>
  );
}
